import React, { Component }  from 'react';

function Footer(){
   return(
      <footer className="flex text-center px-4 py-8 justify-center">
      <p className="text-sm">
        Copyright 2021 • Made From &hearts;
      </p>
    </footer>
   )
}
export default Footer;